import { Box, Text } from '@chakra-ui/react';

interface ExtracurricularCardProps {
    title: string;
    name: string;
    startDate: string;
    endDate: string;
}

export default function ExtracurricularCard({
    endDate,
    name,
    startDate,
    title
}: ExtracurricularCardProps) {
    const formattedDates = `${new Date(Number(startDate)).getMonth()}/${new Date(
        Number(startDate)
    ).getFullYear()} to ${new Date(Number(endDate)).getMonth()}/${new Date(Number(endDate)).getFullYear()}`;

    return (
        <Box pt="6" pb="6">
            <Text fontSize="14px" color="midnight.300">
                {formattedDates}
            </Text>
            <Text fontSize="18px" fontWeight="600" color="var(--chakra-colors-midnight-500)" mb="2">
                {title}
            </Text>
            <Text fontSize="16px" color="var(--chakra-colors-midnight-500)">
                {name}
            </Text>
        </Box>
    );
}
